import { fetchAndParseJson } from "../../../../common-deprecated/utils";
import Debug from "../../../../common-deprecated/Debug";
import type {
    MakolabInsuranceResponseType,
    ParsedInsuranceRateType,
} from "../../../shared-logic/types/FinanceInsuranceRateTypes";
import type { FetchAndParseJsonType } from "../../../../common-deprecated/types/CommonTypes";
import type { ExternalConfigType } from "../../../shared-logic/types/ExternalPriceType";
import type { BnbSettingsType } from "../redux/reducers/BnbSettingsReducer";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { showAccessoriesRate } from "./settings/bnbFinanceSettingUtils";
import type { ParsedMonthlyRateType } from "../../../../common-deprecated/types/FinanceInsuranceRateTypes";
import { calcFind } from "../../../shared-logic/utils/formatters/formatFinance";
import {
    fetchMonthlyRate as fetchMonthlyRateGeneric,
    getLegalText,
} from "../../../shared-logic/utils/FinanceInsuranceRate";

export const fetchMonthlyRate = async (
    settings: CommonSettingsType,
    bnbSettings: BnbSettingsType,
    config: ExternalConfigType,
    selectedItems?: string[] | null,
    unSelectedItems?: string[] | null,
    fetchAndParseJsonOverwrite?: FetchAndParseJsonType,
): Promise<ParsedMonthlyRateType> => {
    return fetchMonthlyRateGeneric(
        settings,
        bnbSettings,
        config,
        showAccessoriesRate(settings, bnbSettings),
        selectedItems,
        unSelectedItems,
        fetchAndParseJsonOverwrite,
    );
};

export const fetchInsuranceRate = async (
    bnbSettings: BnbSettingsType,
    config: ExternalConfigType,
    fetchAndParseJsonOverwrite?: FetchAndParseJsonType,
): Promise<ParsedInsuranceRateType> => {
    const response: Partial<ParsedInsuranceRateType> = {};
    const loader = fetchAndParseJsonOverwrite || fetchAndParseJson;
    const insuranceRate: MakolabInsuranceResponseType = await loader(
        bnbSettings.insuranceRate,
        "insurance rate",
        config,
    );
    const calculations = insuranceRate?.Quotation?.Calculations?.Calculation;
    const legalTextBody = {
        ...config,
        Legal_Text_ID: insuranceRate?.Quotation?.Legal_Text_ID || "",
        Execution_ID: insuranceRate?.Quotation?.Execution_ID || "",
    };
    response.legalText = await getLegalText(bnbSettings.insuranceRateDisclaimer, legalTextBody, loader);

    let total: string | null = null;
    if (calculations?.length) {
        total =
            calcFind(calculations, "INTEGRATED_CAR_CONFIG_PREMIUM") ||
            calcFind(calculations, "MONTHLY_TOTAL_INSURANCE_AMOUNT");

        response.quoteInfo = {};
        calculations.forEach((calc) => {
            response.quoteInfo![calc.Name] = { value: calc.Value, formatted: calc.Formatted };
        });
    } else {
        Debug.error("No calculations found in insurance rate response");
    }

    response.total = Number(total) || 0;
    return response as ParsedInsuranceRateType;
};
